import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Footer from './footer';
import Header from './header';
import apiUrl from './base_url';
import '../components/cssfile/question_paper.css';
import '../components/cssfile/job.css';
import { FaArrowRight, FaBriefcase, FaClipboardCheck, FaTrophy } from 'react-icons/fa';

class Job extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      job: [],
      admit: [],
      result: [],
      loading: true,
      error: null,
    };
  }

  componentDidMount() {
    axios
      .get(apiUrl + 'serverside/latest_job.php')
      .then((response) => {
        const data = Array.isArray(response.data) ? response.data : [];

        this.setState({
          job: data.filter(
            item =>
              item.category === 'notification' &&
              item.exam_category === 'job'
          ),

          admit: data.filter(
            item =>
              item.category === 'admitcard' &&
              item.exam_category === 'job'
          ),

          result: data.filter(
            item =>
              item.category === 'result' &&
              item.exam_category === 'job'
          ),

          loading: false,
          error: null,
        });
      })
      .catch((error) => {
        console.error('Job API Error:', error);

        this.setState({
          error: 'There was an error fetching the data!',
          loading: false,
        });
      });
  }

  createSlug = (text) => {
    return String(text || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  renderSection = (title, sectionItems, type) => {
    const icons = {
      jobs: <FaBriefcase />,
      admit: <FaClipboardCheck />,
      result: <FaTrophy />,
    };

    const descriptions = {
      jobs: 'Latest recruitment notifications and job opportunities',
      admit: 'Latest admit cards and examination updates',
      result: 'Latest examination results and score updates',
    };

    return (
      <div className="col-lg-4 col-md-6 mb-4">
        <div className={`job-section-card job-section-${type}`}>

          {/* Header */}
          <div className="job-section-header">
            <div className="job-section-icon">
              {icons[type]}
            </div>

            <div className="job-section-heading">
              <h3>{title}</h3>

              <p>
                {descriptions[type]}
              </p>
            </div>

            <div className="job-section-count">
              {sectionItems.length}
            </div>
          </div>

          {/* List */}
          <div className="job-section-body">

            {sectionItems.length > 0 ? (

              <div className="job-list">

                {sectionItems.slice(0, 10).map((item, index) => {

                  const slug = this.createSlug(
                    item.topic_name
                  );

                  return (
                    <Link
                      key={item.id || index}
                      to={{
                        pathname: `/job_detail/${slug}`,
                        state: {
                          url: item.url,
                          id: item.id,
                        },
                      }}
                      className="job-list-item"
                    >

                      <div className="job-list-number">
                        {String(index + 1).padStart(2, '0')}
                      </div>

                      <div className="job-list-content">

                        <h4>
                          {item.topic_name}
                        </h4>

                        <span>
                          View Details
                        </span>

                      </div>

                      <div className="job-list-arrow">
                        <FaArrowRight />
                      </div>

                    </Link>
                  );
                })}

              </div>

            ) : (

              <div className="job-empty">

                <div className="job-empty-icon">
                  {icons[type]}
                </div>

                <h4>
                  No {title} Available
                </h4>

                <p>
                  New updates will appear here.
                </p>

              </div>

            )}

          </div>

          {/* Footer */}
          {sectionItems.length > 10 && (
            <div className="job-section-footer">
              Showing latest 10 updates
            </div>
          )}

        </div>
      </div>
    );
  };

  render() {
    const {
      job,
      admit,
      result,
      loading,
      error,
    } = this.state;

    if (loading) {
      return (
        <div className="job-page">
          <Header />

          <div className="job-loading">
            <div className="job-loading-spinner" />

            <h3>
              Loading Latest Updates
            </h3>

            <p>
              Please wait while we fetch the latest information.
            </p>
          </div>

          <Footer />
        </div>
      );
    }

    if (error) {
      return (
        <div className="job-page">
          <Header />

          <div className="job-error">
            <div className="job-error-icon">
              !
            </div>

            <h3>
              Unable to Load Updates
            </h3>

            <p>
              {error}
            </p>

            <button
              type="button"
              className="job-retry-button"
              onClick={() => window.location.reload()}
            >
              Try Again
            </button>
          </div>

          <Footer />
        </div>
      );
    }

    return (
      <div className="job-page">

        <Header />

        {/* ================= HERO ================= */}

        <section className="job-hero">

          <div className="job-hero-content">

            <span className="job-hero-label">
              ERWATODAY CAREER UPDATES
            </span>

            <h1>
              Latest Job Updates
            </h1>

            <p>
              Stay updated with the latest government jobs,
              admit cards and examination results.
            </p>

          </div>

        </section>

        {/* ================= CONTENT ================= */}

        <main className="job-content">

          <div className="container">

            <div className="job-page-heading">

              <div>
                <span className="job-heading-label">
                  LATEST INFORMATION
                </span>

                <h2>
                  Government Exam Updates
                </h2>

                <p>
                  Find the latest recruitment notifications,
                  admit cards and results in one place.
                </p>
              </div>

            </div>

            <div className="row gy-4">

              {this.renderSection(
                'Latest Jobs',
                job,
                'jobs'
              )}

              {this.renderSection(
                'Admit Cards',
                admit,
                'admit'
              )}

              {this.renderSection(
                'Results',
                result,
                'result'
              )}

            </div>

          </div>

        </main>

        <Footer />

      </div>
    );
  }
}

export default Job;